import { UserRoleService } from '../services/userRoleServices';

import { UserRoleAction } from '../types/UserRoleAction';
import { UserRoleBody } from '../types/UserRolesBody';
import { rolesEnum } from '../types/RolesEnumBody';
const UserRoleList = () => (dispatch: any) => {
    const success = (data: UserRoleBody[]): UserRoleAction =>
        ({ type: 'UserRole_List_SUCCESS', data });
    const failure = (error: string): UserRoleAction =>
        ({ type: 'UserRole_List_FAILED', error });


    UserRoleService.listUserRoles().then((res: any) => { dispatch(success(res)) }).catch(err => { dispatch(failure(err)) });
}

const getRolesEnumType = () => (dispatch: any) => {
    const success = (data: rolesEnum[]): UserRoleAction =>
        ({ type: 'UserRole_Enum_SUCCESS', data });

    UserRoleService.getRolesEnum()
        .then((res: any) => dispatch(success(res)));
}

const getRolesCount = () => (dispatch: any) => {
    const success = (data: number): UserRoleAction =>
        ({ type: 'UserRole_List_COUNT_SUCCESS', data });

    UserRoleService.getRolesCount()
        .then((res: any) => dispatch(success(res)));
}

const addRole = (role: UserRoleBody) => (dispatch: any) => {
    const success = (data: UserRoleBody): UserRoleAction =>
        ({ type: 'UserRole_ADD_SUCCESS', data });
    dispatch(success(role));
}

const deleteRole = (id: string, roleName: string) => {
    return UserRoleService.deleteRole(id, roleName);
}

export {
    UserRoleList,
    getRolesEnumType,
    getRolesCount,
    deleteRole,
    addRole,
};